import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  @Input() isLoading: boolean = true;
}
